import { Component, inject, model } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { PhysicalInventoryService } from 'src/app/services/inventory/physical-inventory.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-physical-inventory-report',
  templateUrl: './physical-inventory-report.component.html',
  styleUrls: ['./physical-inventory-report.component.scss'],
  standalone: false
})
export class PhysicalInventoryReportComponent {

  private readonly physicalInventoryService = inject(PhysicalInventoryService);
  private readonly toastHandlerService = inject(ToastHandlerService);

  physicalInventoryId = model<number>(0);

  dataReport: CustomTableReport;
  dataReportBlank: CustomTableReport = {
    captionDescription: [],
    captionFilters: [],
    headers: [],
    data: [],
    totals: []
  };
  listReport: any[] = [
    { label: 'Pendientes por dos conteo', value: 1 },
    { label: 'Pendientes por un conteo', value: 2 },
    { label: 'Pendientes por 3er conteo', value: 3 },
    { label: 'Informe General', value: 4 },
    { label: 'Informe Gral. Costeado - Detallado', value: 5 },
    { label: 'Informe Gral. Costeado - Resumido', value: 6 },
    { label: 'Informe Definitivo', value: 7 }
  ];
  selectedReport: number = 0;
  showReport: boolean = false;

  changeReport(selectedReport: number) {
    if (!this.validatePhysicalInventorySelected()) {
      this.selectedReport = 0;
      this.dataReport = this.dataReportBlank;
      return;
    }

    this.selectedReport = selectedReport;

    this.querySelectedReport();
  }

  async exportExcel() {
    if (this.showReport) {
      try {
        const response = await firstValueFrom(this.physicalInventoryService.exportPhysicalInventoryReport(this.physicalInventoryId(), this.selectedReport));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Informe de Inventario Físico.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  onReportsTabSelected(physicalInventoryIdFromParent?: number) {
    if (typeof physicalInventoryIdFromParent === 'number') {
      this.physicalInventoryId.set(physicalInventoryIdFromParent);
    }

    if (!this.validatePhysicalInventorySelected()) {
      return;
    }

    if (this.selectedReport !== 0) {
      this.querySelectedReport();
    }
  }

  printReport() {
    if (this.showReport) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  private async querySelectedReport() {
    if (this.selectedReport === 0) {
      return;
    }

    try {
      const response = await firstValueFrom(
        this.physicalInventoryService.getPhysicalInventoryReport(this.physicalInventoryId(), this.selectedReport)
      );
      if (response && response.data && response.data.length > 0) {
        this.dataReport = response;
        this.showReport = true;
      } else {
        this.dataReport = this.dataReportBlank;
        this.showReport = false;
      }
    } catch (error) {
      this.dataReport = this.dataReportBlank;
      this.showReport = false;
      console.error('Error al consultar el informe de inventario físico.', error);
    }
  }

  reportSelected(): boolean {
    if (this.selectedReport === 5 || this.selectedReport === 6 || this.selectedReport === 7) {
      return true;
    }
    return false;
  }

  private validatePhysicalInventorySelected(): boolean {
    if (!this.physicalInventoryId() || this.physicalInventoryId() === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un inventario físico en la pestaña de capturas.'
      );
      return false;
    }

    return true;
  }

}
